import { dateFmt, durationFmt } from "../../utils/date";

import React from "react";
import { SortableTable } from "./SortableTable";
import { getColumns } from "../../utils/ordering";
import { useSettings } from "../../utils/Settings";

export function TableDateRange({
  recordName,
  data,
  reviewAccess = false,
  ordering,
  setOrdering,
  nameColumn,
  seniorityLevel = false,
}) {
  const { data: dataSettings, isFetching: isAccessPending } = useSettings();

  if (isAccessPending) {
    return null;
  }

  const reviewAccessActive = dataSettings
    ? dataSettings.find((setting) => setting.key === "REVIEW_ACCESS_ACTIVE")
        .value === "True"
    : false;

  const columns = getColumns(
    [
      {
        title: recordName,
        dataIndex: "name",
        orderingName: nameColumn,
        display: !!recordName,
      },
      {
        title: "Nível de senioridade",
        dataIndex: "seniorityLevel",
        render: (seniorityLevel) => seniorityLevel ?? "-",
        orderingName: "seniority_level",
        display: !!seniorityLevel,
      },
      {
        title: "Filial",
        dataIndex: "branch_corporation",
        render: (branch_corporation) => branch_corporation ?? "-",
        orderingName: "branch_corporation",
        display: recordName === "Empresa",
      },
      {
        title: "Vínculo",
        dataIndex: "contract_type",
        render: (contract_type) => contract_type ?? "-",
        orderingName: "contract_type",
        display: recordName === "Empresa",
      },
      {
        title: "Início",
        dataIndex: "startDate",
        render: (date) => dateFmt(date),
        orderingName: "timespan_lower",
        display: true,
      },
      {
        title: "Fim",
        dataIndex: "endDate",
        render: (date) => dateFmt(date),
        orderingName: "timespan_upper",
        display: true,
      },
      {
        title: "Duração",
        dataIndex: "duration",
        render: (_, record) => durationFmt(record.startDate, record.endDate),
        orderingName: "duration",
        display: true,
      },
      {
        title: "Revisão de acessos",
        dataIndex: "reviewAccess",
        render: (reviewAccess) => (reviewAccess ? "Sim" : "Não"),
        display: reviewAccess && reviewAccessActive,
      },
    ],
    ordering,
  );

  return (
    <SortableTable
      data={data}
      columns={columns}
      ordering={ordering}
      setOrdering={setOrdering}
    />
  );
}

export function TableActiveDateRange({
  recordName,
  data,
  ordering,
  setOrdering,
  nameColumn,
}) {
  const columns = getColumns(
    [
      {
        title: recordName,
        dataIndex: "name",
        orderingName: nameColumn,
        display: !!recordName,
      },
      {
        title: "Início",
        dataIndex: "startDate",
        render: (date) => dateFmt(date),
        orderingName: "timespan_lower",
        display: true,
      },
      {
        title: "Duração",
        dataIndex: "duration",
        render: (_, record) => durationFmt(record.startDate, record.endDate),
        orderingName: "duration",
        display: true,
      },
    ],
    ordering,
  );

  return (
    <SortableTable
      data={data}
      columns={columns}
      ordering={ordering}
      setOrdering={setOrdering}
    />
  );
}
